<template>
  <app-card-amostra-skeleton v-bind="$attrs" v-on="$listeners" :actions="actions"
   class="my-2">
    <template #contrato >
    <div v-if="value !== null" class="cardsecadorlote">
      <div v-if="value.id" class="idsecadorlote"> {{ value.id }} </div>
      <div v-if="value.amodataamostra">
        {{$_formataData(value.amodataamostra,'DD/MM/YYYY ')}} 
        {{$_formataData(value.amodataamostra,'HH:mm -')}}  
      </div>
      <div v-if="value.amoidusuario && value.amooperador">
         {{value.amoidusuario}} - {{value.amooperador}}
      </div>
    </div>
    <div class="header__container" v-if="!semBotoes && position">
      <v-btn icon class="header__btn-editar">
        <v-icon large @click="$emit('onClickEditar', value.id)">
          mdi-pencil-box-outline
        </v-icon>
      </v-btn> 
      <v-btn icon class="header__btn-editar remover">
        <v-icon large @click="$emit('onClickRemover', value.id)">
          mdi-close-box-outline
        </v-icon>
      </v-btn> 
    </div>

     </template>
     <template #detalhe1>
      <span v-if="value.amostatus">Status: {{value.amostatus}}
        <br>
      </span>
      <span v-if="value.amofluxoar">Fluxo Ar: {{value.amofluxoar}}
        <br>
      </span>
      <span v-if="value.amoumidade">Umidade:  {{value.amoumidade}}%
        <br>
      </span>
      <span v-if="value.amoumidadecima">Umidade Cima: {{value.amoumidadecima}}%
        <br>
      </span>
      <span v-if="value.amoumidademeio">Umidade Meio: {{value.amoumidademeio}}%
        <br>
      </span>
      <span v-if="value.amoumidadebaixo">Umidade Baixo: {{value.amoumidadebaixo}}%
        <br>
      </span>
      <span v-if="value.amoobservacao">Observação: {{value.amoobservacao}}
        <br>
      </span>
     </template>
  </app-card-amostra-skeleton>
</template>

<script>
import moment from 'moment-timezone';
import AppCardAmostraSkeleton from './Skeleton.vue';

export default {
  name: 'AppCardAmostra',

  components: {
    AppCardAmostraSkeleton,
  },

  methods: {
    // FormataData(date) {
    //   // return moment(date, 'YYYY-MM-DD').format('DD/MM-HH:MM');
    //   return moment.tz(date, 'America/Sao_Paulo').local().format('DD/MM-HH:mm');
    // },

    $_formataData(date, mascara) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(mascara);
    },

    $_temDescricao(value) {
      // VUE não suporta optional chaining direto no template.
      if (value.produto?.prodescricao) {
        return true;
      }
      return false;
    },

    $_emitter() {
      this.$emit('innerClick', this.value.id);
    },
  },

  props: {
    value: Object,
    actions: Boolean,
    semBotoes: Boolean,
    position: Boolean
  },

  watch: {
    value: {
      immediate:true,
      deep:true,
      handler() {
        
      }
    }
  }
};
</script>
/<style scoped>
#principal{
  display: block;
}

.flex-container {
  display: flex;
}

.flex-container > * {
  margin-right: 3px;
}

.idsecadorlote {
  margin-right: 10px;
}

.cardsecadorlote {
  display: flex;
  flex-wrap: wrap;

}
.header__container {
  display: flex;
  flex-direction: column;
  float: right;
}

.header__btn-editar {
  transform: translateY(-100%) translateX(10px);
}

.header__btn-editar:hover {
  color: #4CAF50;
}

.remover:hover {
  color: #a31414;
}

</style>